import { render, staticRenderFns } from "./RelatedEvents.vue?vue&type=template&id=c08bb80e&scoped=true&"
import script from "./RelatedEvents.vue?vue&type=script&lang=js&"
export * from "./RelatedEvents.vue?vue&type=script&lang=js&"
import style0 from "./RelatedEvents.vue?vue&type=style&index=0&id=c08bb80e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08bb80e",
  null
  
)

export default component.exports